import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { routerTranslation } from "./services/translations/routerTranslation";
import { masterTranslation } from "./services/translations/masterTranslation";
import { reportTranslation } from "./services/translations/reportTranslation";
import { transactionTranslation } from "./services/translations/transactionTranslation";
import { submissionTranslation } from "./services/translations/submissionTranslation";
import { subscriptionsTranslation } from "./services/translations/subscriptionsTranslation";
import { companyTranslation } from "./services/translations/companyTranslation";
import { teamTranslation } from "./services/translations/teamTranslation";
import { usersTranslation } from "./services/translations/usersTranslation";
import { plansTranslation } from "./services/translations/plansTranslation";
import { settingsTranslation } from "./services/translations/settingsTranslation";
import { accountTranslation } from "./services/translations/accountTranslation";
import { careersTranslation } from "./services/translations/careersTranslation";
import { blogsTranslation } from "./services/translations/blogsTranslation";
import { newsTranslation } from "./services/translations/newsTranslation";
import { companyCertificatesTranslation } from "./services/translations/companyCertificatesTranslation";
import { companyFilesTranslation } from "./services/translations/companyFilesTranslation";
import { membershipTranslation } from "./services/translations/membershipTranslation";
import { serviceTranslation } from "./services/translations/serviceTranslation";
import { contactusTranslation } from "./services/translations/contactusTranslation";
import { faqTranslation } from "./services/translations/faqTranslation";
import { ourValuesTranslation } from "./services/translations/ourValuesTranslation";
import { newsLetterTranslation } from "./services/translations/newsLetterTranslation";
import { customPagesTranslation } from "./services/translations/customPagesTranslation";
import { customersTranslation } from "./services/translations/customersTranslation";
import { partnersTranslation } from "./services/translations/partnersTranslation";
import { teamMembersTranslation } from "./services/translations/teamMembersTranslation";
import { tutorialTranslation } from "./services/translations/tutorialTranslation";
import { socialMediaTranslation } from "./services/translations/socialMediaTranslation";
import { pagesIntroductionTranslation } from "./services/translations/pagesIntroductionTranslation";
import { generalSettingTranslation } from "./services/translations/generalSettingTranslation";
import { addEditPlanTranslation } from "./services/translations/addEditPlanTranslation";
import { templatesTranslation } from "./services/translations/templatesTranslation";
import { landingSliderTranslation } from "./services/translations/landingSliderTranslation";
import { sitemapTranslation } from "./services/translations/sitemapTranslation";
import { landingGeneralSettingTranslation } from "./services/translations/landingGeneralSettingTranslation";
import { dsgTranslation } from "./services/translations/dsgTranslation";
import { invoiceTranslation } from "./services/translations/invoiceTranslation";
import { trustedTranslation } from "./services/translations/trustedTranslation";

const savedLanguage = localStorage.getItem("language") || "ar";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        ...routerTranslation.en,
        "Sign in": "Sign in",
        "Email": "Email",
        "Enter Email": "Enter Email",
        "Password": "Password",
        "Enter Password": "Enter Password",
        "Login Failed": "Login Failed",
        "Invalid email format": "Invalid email format",
        "Email is required": "Email is required",
        "Password must be at least 8 characters": "Password must be at least 8 characters",
        "Password is required": "Password is required",
        "HaatSign Logo": "HaatSign Logo",
        "Account": "Account",
        "Language": "Language",
        "SignOut": "Sign Out",
        "Back to Home": "Back to Home",
        "Search": "Search ...",
       "Enter the OTP": "Enter the OTP",
        "OTP is required": "OTP is required",
        "Login": "Login",
        "Verify OTP":"Verify OTP",
        "Supported formats": "Supported formats",
        "Download": "Download",
        "Download PDF": "Download PDF",
        "Download Excel": "Download Excel",
        "There are no records to display": "There are no records to display",
        "Select...":"Select...",
        "Supported formats: PDF, DOCX":"Supported formats: PDF, DOCX",
        "rowsPerPage": "Rows per page:",
        "of": "of",
        "all": "all",
        ...templatesTranslation.en,
        ...addEditPlanTranslation.en,
        ...generalSettingTranslation.en,
        ...pagesIntroductionTranslation.en,
        ...customPagesTranslation.en,
        ...customersTranslation.en,
        ...partnersTranslation.en,
        ...teamMembersTranslation.en,
        ...tutorialTranslation.en,
        ...socialMediaTranslation.en,
        ...masterTranslation.en,
        ...reportTranslation.en,
        ...transactionTranslation.en,
        ...submissionTranslation.en,
        ...subscriptionsTranslation.en,
        ...companyTranslation.en,
        ...teamTranslation.en,
        ...usersTranslation.en,
        ...plansTranslation.en,
        ...settingsTranslation.en,
        ...accountTranslation.en,
        ...careersTranslation.en,
        ...blogsTranslation.en,
        ...newsTranslation.en,
        ...companyCertificatesTranslation.en,
        ...companyFilesTranslation.en,
        ...membershipTranslation.en,
        ...serviceTranslation.en,
        ...contactusTranslation.en,
        ...faqTranslation.en,
        ...ourValuesTranslation.en,
        ...newsLetterTranslation.en,
        ...landingSliderTranslation.en,
        ...sitemapTranslation.en,
        ...landingGeneralSettingTranslation.en,
        ...dsgTranslation.en,
        ...invoiceTranslation.en,
        ...trustedTranslation.en
      },
    },
    ar: {
      translation: {
        ...routerTranslation.ar,
        "Sign in": "تسجيل الدخول",
        "Email": "البريد الإلكتروني",
        "Enter Email": "أدخل البريد الإلكتروني",
        "Password": "كلمة المرور",
        "Enter Password": "أدخل كلمة المرور",
        "Login Failed": "فشل تسجيل الدخول",
        "Invalid email format": "تنسيق البريد الإلكتروني غير صالح",
        "Email is required": "البريد الإلكتروني مطلوب",
        "Password must be at least 8 characters": "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل",
        "Password is required": "كلمة المرور مطلوبة",
        "HaatSign Logo": "شعار HaatSign",
        "Account": "الحساب",
        "Language": "اللغة",
        "SignOut": "تسجيل الخروج",
        "Back to Home": "العودة إلى الصفحة الرئيسية",
        "Search": "بحث ...",
        "Enter the OTP":"أدخل رمز التحقق",
        "OTP is required": "رمز التحقق مطلوب",
        "Login": "تسجيل الدخول",
        "Verify OTP":"تحقق من رمز التحقق",
        "Supported formats": "الصيغ المدعومة",
        "Download": "تحميل",
        "Download PDF": "تحميل PDF",
        "Download Excel": "تحميل Excel",
        "There are no records to display": "لا توجد سجلات لعرضها",
        "Select...":"اختر...",
        "Supported formats: PDF, DOCX":"الصيغ المدعومة: PDF، DOCX",
        "rowsPerPage": "عدد الصفوف في الصفحة:",
        "of": "من",
        "all": "الكل",
        ...templatesTranslation.ar,
        ...addEditPlanTranslation.ar,
        ...generalSettingTranslation.ar,
        ...pagesIntroductionTranslation.ar,
        ...customPagesTranslation.ar,
        ...customersTranslation.ar,
        ...partnersTranslation.ar,
        ...teamMembersTranslation.ar,
        ...tutorialTranslation.ar,
        ...socialMediaTranslation.ar,
        ...masterTranslation.ar,
        ...reportTranslation.ar,
        ...transactionTranslation.ar,
        ...submissionTranslation.ar,
        ...subscriptionsTranslation.ar,
        ...companyTranslation.ar,
        ...teamTranslation.ar,
        ...usersTranslation.ar,
        ...plansTranslation.ar,
        ...settingsTranslation.ar,
        ...accountTranslation.ar,
        ...careersTranslation.ar,
        ...blogsTranslation.ar,
        ...newsTranslation.ar,
        ...companyCertificatesTranslation.ar,
        ...companyFilesTranslation.ar,
        ...membershipTranslation.ar,
        ...serviceTranslation.ar,
        ...contactusTranslation.ar,
        ...faqTranslation.ar,
        ...ourValuesTranslation.ar,
        ...newsLetterTranslation.ar,
        ...landingSliderTranslation.ar,
        ...sitemapTranslation.ar,
        ...landingGeneralSettingTranslation.ar,
        ...dsgTranslation.ar,
        ...invoiceTranslation.ar,
        ...trustedTranslation.ar
      },
    },
  },
  lng: savedLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

const toLanguageCode = (lng) =>
  lng === "ar" || lng === "العربية" ? "ar" : "en";

const updateDocumentDirection = (lng) => {
  const code = toLanguageCode(lng);
  document.documentElement.setAttribute("dir", code === "ar" ? "rtl" : "ltr");
  document.documentElement.setAttribute("lang", code);
};

updateDocumentDirection(savedLanguage);

i18n.on("languageChanged", (lng) => {
  localStorage.setItem("language", lng);
  updateDocumentDirection(lng);
});


export default i18n;
